import { motion } from 'framer-motion';

const ServicesSection = () => {
  const services = [
    { 
      name: 'FOH Ceiling Mounted Display Shelving', 
      image: '/projects/2024 FOH 09.JPG',
      location: 'Premium Installation'
    },
    { 
      name: 'FOH Circular Bar Counter', 
      image: '/projects/2019 FOH 19.jpg',
      location: 'Premium Kitchen Setup'
    },
    { 
      name: 'Bar Counters', 
      image: '/projects/2024 BAR COUNTER 04.jpg',
      location: 'FOH Circular Bar Counter'
    },
    { 
      name: 'BBQ Grills', 
      image: '/projects/2025 BBQ 1.JPG',
      location: 'Custom Grill Stations'
    },
    { 
      name: 'Cheese Rooms', 
      image: '/projects/2024 CHEESE ROOM 10.jpg',
      location: 'Temperature Controlled'
    },
    { 
      name: 'Cold Room', 
      image: '/projects/2024 FZN 1.jpg',
      location: 'Walk-in Storage'
    },
    { 
      name: 'Concession Counter', 
      image: '/projects/2023 CC 08.jpg',
      location: 'Cinepolis Cinema'
    },
    { 
      name: 'Culinary School', 
      image: '/projects/2024 CULINARY SCHOOL 1.jpg',
      location: 'Les Roches, Abu Dhabi'
    },
    { 
      name: 'Fish Tank', 
      image: '/projects/2020 FISH TANK 1.jpg',
      location: 'Le Meridien Dubai'
    },
    { 
      name: 'Food Trucks', 
      image: '/projects/2019 FOOD TRUCKS 7.jpg',
      location: 'Mobile Solutions'
    },
    { 
      name: 'Front of House', 
      image: '/projects/2024 FOH 02.JPG',
      location: 'Front FOH Overhead Display Shelves'
    },
    { 
      name: 'Pizza Ovens', 
      image: '/projects/2015 PIZZA OVEN 1.jpg',
      location: 'Bread Street Kitchen, Atlantis Dubai'
    },
    { 
      name: 'Refrigerated Displays', 
      image: '/projects/2024 Pastry display refg drawersIMG_0232.JPG',
      location: 'Jewellery Box Refrigerated Display with Drawers'
    },
    { 
      name: 'Wine Chillers', 
      image: '/projects/2024 Wine chillers 1.JPG',
      location: 'Custom Wine Cellars'
    },
  ];

  return (
    <section
      id="services"
      className="py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-24 bg-[#F5F1EB]"
      data-testid="services-section"
    >
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <p className="text-xs uppercase tracking-[0.3em] font-medium text-[#2C6E63] mb-4" data-testid="services-overline">
            What We Do
          </p>
          <h2 className="font-heading text-4xl sm:text-5xl font-light tracking-tight text-[#2D3436] mb-6" data-testid="services-heading">
            Range of Services & Products
          </h2>
          <motion.div 
            initial={{ width: 0 }}
            whileInView={{ width: 64 }}
            transition={{ duration: 1, delay: 0.3 }}
            viewport={{ once: true }}
            className="h-px bg-[#D4C4A8] mx-auto"
          ></motion.div>
        </motion.div>

        {/* Services Grid - 2 columns */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.08, ease: [0.215, 0.61, 0.355, 1] }}
              viewport={{ once: true, margin: "-50px" }}
              className="group relative aspect-square overflow-hidden cursor-pointer"
              data-testid={`service-card-${index}`}
            >
              {/* Image */}
              <motion.img
                src={service.image}
                alt={service.name}
                className="w-full h-full object-cover"
                whileHover={{ scale: 1.08 }}
                transition={{ duration: 0.8, ease: [0.215, 0.61, 0.355, 1] }}
              />
              
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#2D3436]/95 via-[#2D3436]/40 to-transparent group-hover:from-[#2D3436]/85 transition-all duration-500" />
              
              {/* Content */}
              <div className="absolute inset-0 flex flex-col justify-end p-8">
                <div className="transform group-hover:-translate-y-2 transition-transform duration-500">
                  <p className="text-[#D4C4A8] text-xs uppercase tracking-[0.2em] mb-2">
                    {service.location}
                  </p>
                  <h3 
                    className="font-heading text-xl md:text-2xl text-white tracking-wide"
                    data-testid={`service-title-${index}`}
                  >
                    {service.name}
                  </h3>
                  {/* Animated underline */}
                  <div className="mt-3 h-px w-0 bg-[#D4C4A8] group-hover:w-16 transition-all duration-500"></div>
                </div>
              </div>

              {/* Corner Accent */}
              <div className="absolute top-6 right-6 w-8 h-8 border-t border-r border-white/30 opacity-0 group-hover:opacity-100 group-hover:w-12 group-hover:h-12 transition-all duration-500" />
              <div className="absolute bottom-6 left-6 w-8 h-8 border-b border-l border-white/30 opacity-0 group-hover:opacity-100 group-hover:w-12 group-hover:h-12 transition-all duration-500" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
